<template>
  <right-long-banner-template :title="getMenuInfo.name">
    <div v-if="!isLoading">
      <base-spinner></base-spinner>
    </div>
    <div class="news-content" v-else>
      <div v-for="(content, index) in getRegularNews" :key="index">
        <div class="box" v-if="!content.hidden">
          <p>{{ formatDate(content.date || content.createdAt) }}</p>
          <router-link id="title" :to="{ name: 'NewsDetail', params: { url: content.url }}">{{ content.title }}</router-link>
          <div class="news-box">
            <img @contextmenu.prevent :src="cacheBuster(content.img)" @click="routeDetail(content.url)">
            <div class="info">
              <p id="summary">{{ content.summary }}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="pagination">
        <div @click="changePage(currentPage - 1)" :disabled="currentPage === 1"><i class="fa-solid fa-angle-left"></i></div>
        <div @click="changePage(1)" v-if="currentPage !== 1">1</div>
        <div v-if="currentPage - 2 >= 1" style="cursor: auto;"><i class="fa-solid fa-ellipsis"></i></div>
        <div style="color: #ffffff; background: #0298cf;">{{ currentPage }}</div>
        <div v-if="currentPage + 2 <= testTotalPage" style="cursor: auto;"><i class="fa-solid fa-ellipsis"></i></div>
        <div @click="changePage(testTotalPage)" v-if="currentPage !== testTotalPage">{{ testTotalPage }}</div>
        <div @click="changePage(currentPage + 1)" :disabled="currentPage === testTotalPage"><i class="fa-solid fa-angle-right"></i></div>
      </div>
    </div>
  </right-long-banner-template>
</template>

<script>
export default {
  data () {
    return {
      pageSize: 6,
      currentPage: 1,
      isLoading: false
    }
  },
  methods: {
    async getNewsByPageData () {
      await this.$store.dispatch('news/getTotalRegularNews')
      await this.$store.dispatch('news/getNewsByPage', { pageNumber: this.currentPage })
    },
    routeDetail (url) {
      this.$router.push({ name: 'NewsDetail', params: { url } })
    },
    changePage (page) {
      if (page >= 1 && page <= this.testTotalPage) {
        this.currentPage = page
        this.getNewsByPageData()
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      }
    },
    cacheBuster (url) {
      return `${url}?cacheBuster=${new Date().getTime()}`
    },
    formatDate (idate) {
      const date = new Date(idate)
      const day = String(date.getDate()).padStart(2, '0')
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const year = date.getFullYear()
      return `${day}/${month}/${year}`
    }
  },
  computed: {
    getMenuInfo () {
      return this.$store.getters['navbar/finalMenu'][1]
    },
    getNews () {
      return this.$store.getters['news/finalNews']
    },
    paginatedData () {
      const start = (this.currentPage - 1) * this.pageSize
      const end = start + this.pageSize
      return this.getNews.slice(start, end)
    },
    totalPages () {
      const tp = Math.ceil(this.testTotalPage / this.pageSize)
      if (tp === 0) return 1
      return tp
    },
    testTotalPage () {
      return this.$store.getters['news/getTotalNews']
    },
    getRegularNews () {
      return this.$store.getters['news/getRegularNewsByPage']
    }
  },
  async created () {
    this.isLoading = false
    await this.getNewsByPageData()
    this.isLoading = true
  }
}
</script>

<style scoped>
  .news-content {
    margin-bottom: 40px;
  }

  .box {
    margin-top: 10px;
  }

  .box a{
    font-size: 22px;
    color: #006884;
    text-decoration: none;
    font-weight: 700;
    transition: color 0.3s ease;
  }

  .box a:hover {
    color: #d23a3a;
  }

  .news-box {
    margin-top: 5px;
    width: 100%;
    display: flex;
    padding-bottom: 15px;
    line-height: 1.4;
    border-bottom: 1px dashed black;
  }

  .news-box img {
    width: 200px;
    height: 130px;
    margin-right: 12px;
    flex-shrink: 0;
    border: 1px solid #d9d9d9;
    cursor: pointer;
    border-radius: 10px;
    object-fit: cover;
  }

  .info {
    height: 130px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
  }

  .news-box a:hover {
    color: #d23a3a;
  }

  .news-box #summary {
    font-size: 16px;
    line-height: 1.6;
  }

  .pagination {
    margin-top: 15px;
    display: flex;
    justify-content: flex-end;
    width: 100%;
    padding: 10px 20px;
    padding-right: 0px;
  }

  .pagination div{
    padding: 10px;
    border: 1px solid #d5d0d0;
    height: 35px;
    width: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: transparent;
    /* color: #0298cf; */
    color: #4d4a4a;
    box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.3);
    margin: 0 5px;
    cursor: pointer;
  }

  @media (max-width: 720px) {
    .box a{
      font-size: 18px;
    }

    .box p{
      font-size: 14px;
    }

    .news-box #summary {
      font-size: 14px;
    }

    .news-box img {
      width: 160px;
    }

    .info {
      -webkit-line-clamp: 6;
    }
  }

  @media (max-width: 485px) {
    .news-box img {
      width: 120px;
      height: 100px;
    }

    .news-box #summary {
      font-size: 12px;
    }

    .info {
      height: 100px;
      -webkit-line-clamp: 5;
    }
  }
</style>
